import {gql} from '@apollo/client';

export const GET_ASSET_CLASS_AND_DABAPRO_DATA = gql`
  query GetAssetClassAndDabaProChartData($filters: OverviewFilters) {
    getAssetClassAndDabaProChartData(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithOverviewResponse {
        data {
          ... on AssetClassAndDabaProChartData {
            assetClass {
              label
              value
            }
            dabaPro {
              label
              value
            }
          }
        }
      }
    }
  }
`;

export const DABA_PRO_SUBSCRIPTION_STATISTICS = gql`
  query GetDabaProSubscriptionStatistics($filters: OverviewFilters) {
    getDabaProSubscriptionStatistics(filters: $filters) {
      ... on Error {
        message
        statusCode
        type
        errorTypeEnum
        retryAfter
      }
      ... on ResponseWithOverviewResponse {
        message
        data {
          ... on DabaProSubscriptionStatisticsData {
            totalRevenue {
              totalAmount
              symbol
              currency
            }
            totalCount
            totalSoldUnits
            totalActive
            totalInactive
          }
        }
      }
    }
  }
`;

export const DABA_PRO_SUBSCRIPTION_MONTHLY_BREAKDOWN = gql`
  query GetDabaProSubscriptionMonthlyBreakdown($year: Int) {
    getDabaProSubscriptionMonthlyBreakdown(year: $year) {
      ... on Error {
        message
        statusCode
        type
        errorTypeEnum
        retryAfter
      }
      ... on ResponseWithOverviewResponse {
        message
        data {
          ... on DabaSubscriptionMonthlyBreakdownData {
            year
            breakdown {
              month
              totalCount
            }
          }
        }
      }
    }
  }
`;

export const GET_DABA_PRO_MEMBERS = gql`
  query GetDabaProMembers($filters: DabaProMembersFilters) {
    getDabaProMembers(filters: $filters) {
      ... on Error {
        message
        statusCode
        type
        errorTypeEnum
        retryAfter
      }
      ... on ResponseWithDabaSubscriptionMembers {
        message
        data {
          user {
            id
            firstName
            email
            lastName
            imageUrl
            currentSessionDetails {
              currentDateTime
            }
            investorProfile {
              identityCard {
                kycStatus
              }
            }
          }
          startDate
          endDate
          isRecurring
          subscriptionType
          hasInvested
          hasPortfolio
          subscriptionStatus
          totalSubscriptions
        }
        pagination {
          hasNextPage
          hasPrevPage
          next
          page
          previous
          total
        }
      }
    }
  }
`;

export const GET_DABA_POWER_USER_DEPOSITS = gql`
  query GetDabaPowerUserDeposits($filters: DabaPowerUserFilters) {
    getDabaPowerUserDeposits(filters: $filters) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithDabaPowerUserDeposits {
        data {
          user {
            id
            firstName
            lastName
            email
            imageUrl
            createdAt
            country
            city
          }
          currency
          totalDeposits
          totalAmount
          lastDeposit
          isProUser
        }
        pagination {
          hasNextPage
          hasPrevPage
          next
          page
          previous
          total
        }
      }
    }
  }
`;

export const GET_DABA_POWER_USER_INVESTMENTS = gql`
  query GetDabaPowerUserInvestments($filters: DabaPowerUserInvestmentFilters) {
    getDabaPowerUserInvestments(filters: $filters) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithDabaPowerUserInvestments {
        data {
          user {
            id
            firstName
            lastName
            email
            imageUrl
            createdAt
            country
            city
          }
          totalInvestments
          lastInvestment
          isProUser
        }
        pagination {
          hasNextPage
          hasPrevPage
          next
          page
          previous
          total
        }
      }
    }
  }
`;

export const GET_DABA_POWER_USER_REFERRALS = gql`
  query GetDabaPowerUserReferrals($filters: DabaPowerUserReferralFilters) {
    getDabaPowerUserReferrals(filters: $filters) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithDabaPowerUserReferrals {
        data {
          users {
            user {
              id
              firstName
              lastName
              email
              imageUrl
              country
              city
            }
            activeReferrals
            inactiveReferrals
            totalReferrals
          }
          ambassadorEligibleCount
        }
        pagination {
          hasNextPage
          hasPrevPage
          next
          page
          previous
          total
        }
      }
    }
  }
`;

export const GET_SIMULATOR_STATS = gql`
  query GetSimulatorStatistics($filters: OverviewFilters) {
    getSimulatorStatistics(filters: $filters) {
      ... on Error {
        message
        statusCode
        type
        errorTypeEnum
        retryAfter
      }
      ... on ResponseWithOverviewResponse {
        message
        data {
          ... on SimulatorStatisticsData {
            totalRevenue {
              symbol
              currency
              totalAmount
            }
            totalTransactions
            totalPremiumSubscribers
            totalActivePremiumSubscribers
            totalVirtualMoneySubscribers
          }
        }
      }
    }
  }
`;

export const GET_SIMULATOR_SUBSCRIPTION_MONTHLY_BREAKDOWN = gql`
  query GetSimulatorSubscriptionMonthlyBreakdown($year: Int) {
    getSimulatorSubscriptionMonthlyBreakdown(year: $year) {
      ... on Error {
        message
        statusCode
        type
        errorTypeEnum
        retryAfter
      }
      ... on ResponseWithOverviewResponse {
        message
        data {
          ... on DabaSubscriptionMonthlyBreakdownData {
            year
            breakdown {
              month
              totalCount
            }
          }
        }
      }
    }
  }
`;

export const GET_WHAT_WOULD_YOU_USE_DABA_FOR_STATISTICS = gql`
  query GetWhatWouldYouUseDabaForStatistics($filters: OverviewFilters) {
    getWhatWouldYouUseDabaForStatistics(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithOverviewResponse {
        data {
          ... on WhatWouldYouUseDabaForStatisticsData {
            statistics {
              value
              label
            }
          }
        }
      }
    }
  }
`;

export const GET_INVESTMENT_PURPOSE_USERS = gql`
  query GetInvestmentPurposeUsers($filters: InvestmentPurposeUsersFilters) {
    getInvestmentPurposeUsers(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithRegionUsers {
        message
        pagination {
          total
          page
          limit
          hasNextPage
          hasPrevPage
          next
          previous
        }
        data {
          id
          userType
          firstName
          lastName
          email
          country
          createdAt
          currentSessionDetails {
            medium
          }
          investorProfile {
            riskNeed {
              investmentPurposes
            }
            isKycApproved
            isAccredited
          }
          userSegments {
            name
          }
        }
      }
    }
  }
`;

/** Fallback purpose labels when statistics return no rows (uses mobile settings copy). */
export const GET_APP_CONFIG_PURPOSE_OPTIONS = gql`
  query GetAppConfigPurposeOptions {
    getAppConfig {
      ... on Error {
        message
        statusCode
      }
      ... on AppConfigType {
        config {
          whatWouldYouUseDabaFor
        }
      }
    }
  }
`;

// Feedback digest (platform-analytics-service). jobs-service builds and sends
// the digest; the dashboard only reads and writes its settings.
const FEEDBACK_DIGEST_SETTINGS_FIELDS = `
  enabled
  frequency
  dayOfWeek
  dayOfMonth
  hourGmt
  slackChannelId
  emailRecipients
  sections
  commentsPerSection
  updatedAt
  lastRun {
    frequency
    periodStart
    status
    attempts
    finishedAt
  }
`;

export const GET_FEEDBACK_DIGEST_SETTINGS = gql`
  query FeedbackDigestSettings {
    getFeedbackDigestSettings {
      __typename
      ... on ResponseWithFeedbackDigestSettings {
        data {
          ${FEEDBACK_DIGEST_SETTINGS_FIELDS}
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const UPDATE_FEEDBACK_DIGEST_SETTINGS = gql`
  mutation UpdateFeedbackDigest($input: FeedbackDigestSettingsInput!) {
    updateFeedbackDigestSettings(input: $input) {
      __typename
      ... on ResponseWithFeedbackDigestSettings {
        message
        data {
          ${FEEDBACK_DIGEST_SETTINGS_FIELDS}
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const SEND_TEST_FEEDBACK_DIGEST = gql`
  mutation SendTestFeedbackDigest {
    sendTestFeedbackDigest {
      __typename
      ... on ResponseWithFeedbackDigestTest {
        message
        data {
          recipient
          requestedAt
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;
